module.exports = __webpack_public_path__ + "img/logo.46545849.png";